import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./../App.css";
import Login from "../pages/Login";
import ReservationManagement from "./../pages/ReservationManagement";
import SalesManagement from "./../pages/SalesManagement";
import SalesManagementByDay from "./../pages/SalesManagement/byDay";
import SalesManagementByMonth from "./../pages/SalesManagement/byMonth";
import SalesManagementByTherapist from "./../pages/SalesManagement/byTherapist";
import CustomerManagement from "./../pages/CustomerManagement";
import DailyReportPage from "./../pages/DailyReport";
import StaffSchedulePage from "./../pages/StaffSchedule";
import TherapistManagement from "./../pages/TherapistManagement";
import TherapistShift from "./../pages/TherapistShift";
import CustomerMaster from "./../pages/CustomerMaster";
import StoreMaster from "./../pages/StoreMaster";
import TherapistMaster from "./../pages/TherapistMaster";
import ReferrerMaster from "./../pages/ReferrerMaster";
import UserMaster from "./../pages/UserMaster";
import AccountMasterCourse from "./../pages/AccountMasterCourse";
import AccountMasterAssign from "./../pages/AccountMasterAssign";
import AccountMasterOption from "./../pages/AccountMasterOption";
import AccountMasterPayment from "./../pages/AccountMasterPayment";
import AccountMasterExtend from "./../pages/AccountMasterExtend";
import Log from "./../pages/Log";
import Auth from "./authRoute";
import NotFound from "../pages/NotFound";
import ActivityLog from "../pages/ActivityLog";
import TherapistShiftView from "../pages/TherapistShiftView";
import AccountMasterEventImage from "../pages/AccountMasterEventImage";
import MonthlyReportPage from "../pages/MonthlyReport";
import BasicInformationPage from "../pages/BasicInformation";
import OutsourcingStatement from "../pages/OutsourcingStatement";
import MonthlyTherapistNomination from "../pages/MonthlyTherapistNomination";

const routeTitles = {
  "/staff_schedule": "スタッフスケジュール",
  "/reservemgr": "予約管理",
  "/salesmgr": "売上集計",
  "/salesmgr_byday": "日別【売上集計】",
  "/salesmgr_bymonth": "月別【売上集計】",
  "/salesmgr_bytherapist": "セラピスト別【売上集計】",
  "/customermgr": "顧客管理",
  "/dailyreport": "日報",
  "/monthlyreport": "月報",
  "/basicinformation": "基本情報",
  "/outsourcing-statement": "業務委託清算書(現金)",
  "/therapistmanagement": "セラピスト管理",
  "/therapistshift": "セラピストのシフト設定",
  "/customermaster": "顧客マスター",
  "/storemaster": "店舗マスター",
  "/therapistmaster": "セラピストマスター",
  "/accountmaster_course": "コース登録",
  "/accountmaster_nomination": "指名",
  "/accountmaster_option": "オプション",
  "/accountmaster_payment": "支払方法",
  "/accountmaster_extend": "延長",
  "/accountmaster_event_image": "イベント追加",
  "/referrermaster": "紹介者マスター",
  "/usermaster": "管理・利用者マスター",
  "/activity_log": "登録・変更履歴のロ",
  "/log": "登録・変更内容のログ",
  "/monthly-therapist-nomination": "月別 セラピスト指名料 設定画面",
};

const DEFAULT_TITLE = "一括管理システム";

function Root() {
  const { pathname } = useLocation();

  useEffect(() => {
    const matchedTitle = routeTitles[pathname];
    document.title = matchedTitle || DEFAULT_TITLE;
  }, [pathname]);

  return (
    <div className="root-wrapper">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/staff_schedule" element={<StaffSchedulePage />} />

        <Route path="/" element={<Auth />}>
          <Route path="/" element={<Navigate to="/staff_schedule" replace />} />
          <Route path="/reservemgr" element={<ReservationManagement />} />
          <Route path="/salesmgr" element={<SalesManagement />} />
          <Route path="/salesmgr_byday" element={<SalesManagementByDay />} />
          <Route
            path="/salesmgr_bymonth"
            element={<SalesManagementByMonth />}
          />
          <Route
            path="/salesmgr_bytherapist"
            element={<SalesManagementByTherapist />}
          />
          <Route path="/customermgr" element={<CustomerManagement />} />
          <Route path="/dailyreport" element={<DailyReportPage />} />
          <Route path="/monthlyreport" element={<MonthlyReportPage />} />
          <Route path="/basicinformation" element={<BasicInformationPage />} />
          <Route
            path="/outsourcing-statement"
            element={<OutsourcingStatement />}
          />

          <Route
            path="/therapistmanagement"
            element={<TherapistManagement />}
          />

          <Route
            path="/therapistshift-therapist-view/:id"
            element={<TherapistShiftView />}
          />

          <Route path="/therapistshift" element={<TherapistShift />} />

          <Route path="/customermaster" element={<CustomerMaster />} />
          <Route path="/storemaster" element={<StoreMaster />} />
          <Route path="/therapistmaster" element={<TherapistMaster />} />
          <Route path="/referrermaster" element={<ReferrerMaster />} />
          <Route path="/usermaster" element={<UserMaster />} />
          <Route
            path="/accountmaster_course"
            element={<AccountMasterCourse />}
          />
          <Route
            path="/accountmaster_nomination"
            element={<AccountMasterAssign />}
          />
          <Route
            path="/accountmaster_option"
            element={<AccountMasterOption />}
          />
          <Route
            path="/accountmaster_payment"
            element={<AccountMasterPayment />}
          />
          <Route
            path="/accountmaster_extend"
            element={<AccountMasterExtend />}
          />
          <Route
            path="/accountmaster_event_image"
            element={<AccountMasterEventImage />}
          />
          <Route path="/activity_log" element={<ActivityLog />} />

          <Route path="/log" element={<Log />} />
          <Route path="/monthly-therapist-nomination" element={<MonthlyTherapistNomination />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default Root;
